import React, { useEffect, useState, useRef } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
interface VideoPlayerProps {
  src: string;
  poster?: string;
}
export function VideoPlayer({
  src,
  poster
}: VideoPlayerProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [isMuted, setIsMuted] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = false;
      videoRef.current.play().catch(() => {
        if (videoRef.current) {
          videoRef.current.muted = true;
          setIsMuted(true);
          videoRef.current.play();
        }
      });
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (videoRef.current) {
          if (!entry.isIntersecting) {
            videoRef.current.muted = true;
            setIsMuted(true);
            videoRef.current.pause();
          } else {
            videoRef.current.play();
          }
        }
      });
    }, {
      threshold: 0.5
    });
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }
    return () => observer.disconnect();
  }, []);
  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(videoRef.current.muted);
    }
  };
  return <div ref={containerRef} className="relative w-full aspect-video rounded-xl overflow-hidden shadow-2xl shadow-orange-500/20 border border-slate-800 bg-black group" data-id="element-61">
      <video ref={videoRef} src={src} poster={poster} className="w-full h-full object-cover" loop playsInline onPlay={() => setIsPlaying(true)} data-id="element-62" />

      {/* ACTIVAR SONIDO button - bottom left */}
      {isMuted && <button onClick={toggleMute} className="absolute bottom-3 left-3 z-20 flex items-center gap-1.5 bg-black/50 backdrop-blur-sm text-white text-xs font-bold px-3 py-1.5 rounded-full border border-white/10 hover:bg-black/70 transition-colors" data-id="element-63">
          <VolumeX className="w-3.5 h-3.5" data-id="element-64" />
          <span data-id="element-65">ACTIVAR SONIDO</span>
        </button>}

      {!isMuted && <button onClick={toggleMute} className="absolute bottom-3 left-3 z-20 flex items-center gap-1.5 bg-black/50 backdrop-blur-sm text-white text-xs font-bold px-3 py-1.5 rounded-full border border-white/10 hover:bg-black/70 transition-colors opacity-0 group-hover:opacity-100" data-id="element-66">
          <Volume2 className="w-3.5 h-3.5" data-id="element-67" />
          <span data-id="element-68">SONIDO ON</span>
        </button>}
    </div>;
}